import { Property } from '../Models/Property';

export const SET_CLAIM_PROPERTY = 'SET_CLAIM_PROPERTY';
export const CLEAR_CLAIM_PROPERTY = 'CLEAR_CLAIM_PROPERTY';

interface ClaimPropertyPayload {
    property: Property;
    timestamp: number;
}

export const setClaimProperty = (property: Property): { type: string; payload: ClaimPropertyPayload } => ({
    type: SET_CLAIM_PROPERTY,
    payload: {
        property,
        timestamp: Date.now()
    }
});

export const clearClaimProperty = () => ({
    type: CLEAR_CLAIM_PROPERTY
});